import { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import moment from 'moment';

import { Button, Divider, Form, Input, Modal, Popconfirm, Select, Table, Tabs, Typography, message } from "antd";
import Link from 'antd/lib/typography/Link';
import { UploadFile } from 'antd/lib/upload/interface';
import Dragger from 'antd/lib/upload/Dragger';
import { DeleteFilled, InboxOutlined } from '@ant-design/icons';

import { ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';
import { getDisplayCompanyId, getMimeType, sortArrayByKey, sortResources } from 'utils/helpers';
import { Company, UserRole } from 'utils/enums';
import { DOCUMENTS_LANGUAGE } from 'utils/objects';

import { getDownloadableResources, getDownloadResources } from "store/app/actions";
import { deleteResource, updateResource, uploadResource, ResourceFiles, getResources, getAllDesc } from "store/app/ipa/actions";

import FileIcon from 'components/Resources/FileIcon';

import { FormsTableProps } from './Proptypes';
import styles from './FormsTable.module.scss';


const { Title } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const FormsTable = (props: FormsTableProps) => {

  const ALL_IPAS = 'ALL';

  const [form] = Form.useForm();
  const [fileAttachments, setFileAttachments] = useState<any[]>([]);
  const [uniqueList, setUniqueList] = useState<any[]>([]);
  const [uniqueList1, setUniqueList1] = useState<any[]>([]);
  const [forms, setForms] = useState<any[]>([]);
  const [forms1, setForms1] = useState<any[]>([]);
  const [activeKey, setActiveKey] = useState('1');
  const [isAddNewDocumentsVisible, setIsAddNewDocumentsVisible] = useState(false);
  const [showEditResource, setShowEditResource] = useState(false);
  const [editModalData, setEditModalData] = useState<any[]>([]);
  const [editDocumentFileLocation, setEditDocumentFileLocation] = useState('');
  const [documentList, setDocumentList] = useState<any>([]);
  const [ipaList, setIpaList] = useState([] as Object[]);

  useEffect(() => {
    refreshFormTabs();
    getIpas();
  }, []);

  const refreshFormTabs = () => {
    getDownloadableResources('FORM', setUniqueList, setForms); 
    getDownloadableResources('Forms(A)', setUniqueList1, setForms1);
  }

  const getDownloadableResources = (materialType: string, setUnique: Function, setForms: Function) => {
    //QA2 is sending BA instead of BAIPA in forms
    return props.getResources(sessionStorage.getItem('user_id')!, materialType, '')
      .then((response: any[]) => {
        let unique = response.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.RmiFileDesc === value.RmiFileDesc
          ))
        );
        let languages: any[] = [];

        setUnique(unique);
        sortResources(response, languages);
        setForms(languages);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      })
  };

  const downloadFile = (filePath: string, companyId: string) => {
    props.getDownloadResources(filePath, companyId)
      .then((response: string) => {
        const mimeType = getMimeType(filePath);
        let blob = new Blob([response], { type: mimeType });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, "_blank", "");
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const openEditDocumentModal = (language1: any, language2: any, language3: any, language4: any) => {

    const documents: any = [];
    if (language1) {
      documents.push(language1);
    }

    if (language2) {
      documents.push(language2);
    }

    if (language3) {
      documents.push(language3);
    }

    if (language4) {
      documents.push(language4);
    }

    setEditModalData(documents);
    setEditDocumentFileLocation(JSON.stringify({ "RmiMaterialType": documents[0]?.RmiMaterialType, "RmiLocationPath": ["Forms\\HCC\\", "Forms\\Hcc\\"].includes(documents[0]?.RmiLocationPath) ? "Forms\\HCC\\" : documents[0]?.RmiLocationPath }));
    setShowEditResource(true);
  }

  const deleteResource = (language1: any, language2: any, language3: any, language4: any) => {
    const deleteParam: any = [];
    if (language1) {
      deleteParam.push(language1);
    }

    if (language2) {
      deleteParam.push(language2);
    }

    if (language3) {
      deleteParam.push(language3);
    }

    if (language4) {
      deleteParam.push(language4);
    }

    props.deleteResource(deleteParam).then((response: any) => {
      for (const file of response) {
        notifier.success(`"${file.RmiFileDesc} - ${file.RmiFileName}" successfully deleted for ${getDisplayCompanyId(file.RmiCompanyId)}.`);
      }
      refreshFormTabs();
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      refreshFormTabs();
    });
  }

  const archiveResource = (language1: any, language2: any, language3: any, language4: any) => {

    const archiveResource: any = [];

    if (language1) {
      archiveResource.push({
        ...language1,
        "RmiNewLocationPath": language1.RmiLocationPath.substr(0, language1.RmiLocationPath.indexOf("\\")) + '\\Archive\\',
        "RmiMaterialType": language1.RmiLocationPath.substr(0, language1.RmiLocationPath.indexOf("\\")) + '(A)',
      });
    }

    if (language2) {
      archiveResource.push({
        ...language2,
        "RmiNewLocationPath": language2.RmiLocationPath.substr(0, language2.RmiLocationPath.indexOf("\\")) + '\\Archive\\',
        "RmiMaterialType": language2.RmiLocationPath.substr(0, language2.RmiLocationPath.indexOf("\\")) + '(A)',
      });
    }

    if (language3) {
      archiveResource.push({
        ...language3,
        "RmiNewLocationPath": language3.RmiLocationPath.substr(0, language3.RmiLocationPath.indexOf("\\")) + '\\Archive\\',
        "RmiMaterialType": language3.RmiLocationPath.substr(0, language3.RmiLocationPath.indexOf("\\")) + '(A)',
      });
    }

    if (language4) {
      archiveResource.push({
        ...language4,
        "RmiNewLocationPath": language4.RmiLocationPath.substr(0, language4.RmiLocationPath.indexOf("\\")) + '\\Archive\\',
        "RmiMaterialType": language4.RmiLocationPath.substr(0, language4.RmiLocationPath.indexOf("\\")) + '(A)',
      });
    }

    props.updateResource(archiveResource).then((response: any) => {
      for (const file of response) {
        notifier.success(`"${file.RmiFileDesc} - ${file.RmiFileName}" successfully archived.`);
      }
      refreshFormTabs();
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      refreshFormTabs();
    });
  }

  const updateFileLocation = (value: string) => {
    const newLocation = JSON.parse(value);
    const newData = editModalData.map((item: ResourceFiles) => ({
        ...item,
        RmiNewLocationPath: newLocation.RmiLocationPath,
        RmiMaterialType: newLocation.RmiMaterialType,
    }));

    setEditDocumentFileLocation(value);
    setEditModalData(newData);
  }

  const currentFormTab = [
    {
      dataIndex: 'RmiFileDesc',
      key: 'RmiFileDesc',
    },
    {
      dataIndex: 'language0',
      key: 'language0',
      render: (_: string, __: any, index: number)=> {
        const fileName1   = forms[index] ? forms[index][0]?.RmiFileName : null;
        const filePath1   = forms[index] ? forms[index][0]?.RmiLocationPath + fileName1 : null;
        const companyId1  = forms[index] ? forms[index][0]?.RmiCompanyId : null;
        const fileName2   = forms[index] ? forms[index][1]?.RmiFileName : null;
        const filePath2   = forms[index] ? forms[index][1]?.RmiLocationPath + fileName2 : null;
        const companyId2  = forms[index] ? forms[index][1]?.RmiCompanyId : null;
        const fileName3   = forms[index] ? forms[index][2]?.RmiFileName : null;
        const filePath3   = forms[index] ? forms[index][2]?.RmiLocationPath + fileName3 : null;
        const companyId3  = forms[index] ? forms[index][2]?.RmiCompanyId : null;
        const fileName4   = forms[index] ? forms[index][3]?.RmiFileName : null;
        const filePath4   = forms[index] ? forms[index][3]?.RmiLocationPath + fileName4 : null;
        const companyId4  = forms[index] ? forms[index][3]?.RmiCompanyId : null;
        return (
          <>
            { fileName1 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath1} fileName={fileName1} companyId={companyId1} />
              <Link className="ml-1" onClick={() => forms[index] && downloadFile(filePath1, companyId1)}>{forms[index] && forms[index][0]?.RmiLanguage}</Link>
              <br/>
            </> : null
            }

            { fileName2 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath2} fileName={fileName2} companyId={companyId2} />
              <Link className="ml-1" onClick={() => forms[index] && downloadFile(filePath2, companyId2)}>{forms[index] && forms[index][1]?.RmiLanguage}</Link>
              <br/>
            </> : null
            }

            { fileName3 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath3} fileName={fileName3} companyId={companyId3} />
              <Link className="ml-1" onClick={() => forms[index] && downloadFile(filePath3, companyId3)}>{forms[index] && forms[index][2]?.RmiLanguage}</Link>
              <br/>
            </> : null
            }

            { fileName4 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath4} fileName={fileName4} companyId={companyId4} />
              <Link className="ml-1" onClick={() => forms[index] && downloadFile(filePath4, companyId4)}>{forms[index] && forms[index][3]?.RmiLanguage}</Link>
            </> : null
            }
          </>
        )
      }
    },
    {
      key: "buttons",
      dataIndex: "buttons",
      render: (_: string, record: any, index: number) =>
        <>
          {sessionStorage.user_role === UserRole.ADMIN ?
            <>
              <Popconfirm
                placement="top"
                title={<><div>Are you sure to archive this file?</div><b>{record.RmiFileDesc}</b></>}
                onConfirm={() => archiveResource(forms[index][0], forms[index][1], forms[index][2], forms[index][3])}
                okText="Yes"
                cancelText="No"
              >
                 <i className="fa fa-solid fa-archive mr-2"></i>
              </Popconfirm>
              <i className="fa fa-solid fa-pen mr-2" onClick={() => openEditDocumentModal(forms[index][0], forms[index][1], forms[index][2], forms[index][3])}></i>
              <Popconfirm
                placement="top"
                title={<><div>Are you sure to delete this file?</div><b>{record.RmiFileDesc}</b></>}
                onConfirm={() => deleteResource(forms[index][0], forms[index][1], forms[index][2], forms[index][3])}
                okText="Yes"
                cancelText="No"
              >
                <i className="fa fa-solid fa-trash"></i>
              </Popconfirm>

            </> : null
          }
        </>
    },
  ];

  const archiveTab = [
    {
      dataIndex: 'RmiFileDesc',
      key: 'RmiFileDesc',
    },
    {
      dataIndex: 'language0',
      key: 'language0',
      render: (_: string, __: any, index: number)=> {
        const fileName1   = forms1[index] ? forms1[index][0]?.RmiFileName : null;
        const filePath1   = forms1[index] ? forms1[index][0]?.RmiLocationPath + fileName1 : null;
        const companyId1  = forms1[index] ? forms1[index][0]?.RmiCompanyId : null;
        const fileName2   = forms1[index] ? forms1[index][1]?.RmiFileName : null;
        const filePath2   = forms1[index] ? forms1[index][1]?.RmiLocationPath + fileName2 : null;
        const companyId2  = forms1[index] ? forms1[index][1]?.RmiCompanyId : null;
        const fileName3   = forms1[index] ? forms1[index][2]?.RmiFileName : null;
        const filePath3   = forms1[index] ? forms1[index][2]?.RmiLocationPath + fileName3 : null;
        const companyId3  = forms1[index] ? forms1[index][2]?.RmiCompanyId : null;
        const fileName4   = forms1[index] ? forms1[index][3]?.RmiFileName : null;
        const filePath4   = forms1[index] ? forms1[index][3]?.RmiLocationPath + fileName4 : null;
        const companyId4  = forms1[index] ? forms1[index][3]?.RmiCompanyId : null;
        return (
          <>
            { fileName1 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath1} fileName={fileName1} companyId={companyId1} />
              <Link className="ml-1" onClick={() => forms1[index] && downloadFile(filePath1, companyId1)}>{forms1[index] && forms1[index][0]?.RmiLanguage}</Link>
              <br/>
            </> : null
            }

            { fileName2 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath2} fileName={fileName2} companyId={companyId2} />
              <Link className="ml-1" onClick={() => forms1[index] && downloadFile(filePath2, companyId2)}>{forms1[index] && forms1[index][1]?.RmiLanguage}</Link>
              <br/>
            </> : null
            }

            { fileName3 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath3} fileName={fileName3} companyId={companyId3} />
              <Link className="ml-1" onClick={() => forms1[index] && downloadFile(filePath3, companyId3)}>{forms1[index] && forms1[index][2]?.RmiLanguage}</Link>
              <br/>
            </> : null
            }

            { fileName4 ?
            <>
              <FileIcon getDownloadResources={props.getDownloadResources} downloadIcon={true} filePath={filePath4} fileName={fileName4} companyId={companyId4} />
              <Link className="ml-1" onClick={() => forms1[index] && downloadFile(filePath4, companyId4)}>{forms1[index] && forms1[index][3]?.RmiLanguage}</Link>
            </> : null
            }
          </>
        )
      }
    },
  ];

  const switchTabs = (activeKey: string) => {
    setActiveKey(activeKey);
  }

  const submitNewDocument = async () => {
    Promise.all(documentList.map(async (currentValue: any) => {
      if (!currentValue.RmiFileDesc) {
        notifier.error(`Document name is required for ${currentValue.File.name}`);
        return false;
      }

      if (!currentValue.RmiLocationPath || !currentValue.RmiMaterialType) {
        notifier.error(`File Location is required for ${currentValue.File.name}`);
        return false;
      }

      if (!currentValue.RmiLanguage) {
        notifier.error(`Language is required for ${currentValue.File.name}`);
        return false;
      }
      
      if (!currentValue.RmiCompanyId) {
        notifier.error(`IPA is required for ${currentValue.File.name}`);
        return false;
      }

      let companyIdList: string[] = [];
      if (currentValue.RmiCompanyId == ALL_IPAS) {
        ipaList.map((option: any, index: number) => {
          companyIdList.push(option.RmiCompanyId);
        });
      } else {
        companyIdList.push(currentValue.RmiCompanyId);
      }
      companyIdList.map((companyId: string) => {
        const createUploadFileData = new FormData();
        createUploadFileData.append("RmiCompanyId", companyId);
        createUploadFileData.append("RmiCreatedBy", sessionStorage.getItem('user_id')!);
        createUploadFileData.append("RmiCreatedDate", moment().toString());
        createUploadFileData.append("RmiFileDesc", currentValue.RmiFileDesc);
        createUploadFileData.append("RmiFileName", currentValue.File.name);
        createUploadFileData.append("RmiLanguage", currentValue.RmiLanguage);
        createUploadFileData.append("RmiLocationPath", currentValue.RmiLocationPath);
        createUploadFileData.append("RmiMaterialType", currentValue.RmiMaterialType);
        createUploadFileData.append("RmiModifiedBy", sessionStorage.getItem('user_id')!);
        createUploadFileData.append("RmiModifiedDate", moment().toString());
        createUploadFileData.append("File", currentValue.File);

        return props.uploadResource(createUploadFileData)
          .then((response: any) => {
            closeAddNewResources();
            notifier.success(`"${response.RmiFileDesc} - ${response.RmiFileName}" successfully uploaded for ${getDisplayCompanyId(response.RmiCompanyId)}.`);
          })
          .catch((err: ErrorResponse) => {
            message.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
            refreshFormTabs();
          });
        });
    }))
  };

  const closeEditResources = () => {
    setEditModalData([]);
    setShowEditResource(false);
    refreshFormTabs();
  };

  const closeAddNewResources = () => {
    setDocumentList([]);
    setIsAddNewDocumentsVisible(false);
    setFileAttachments([]);
    refreshFormTabs();
  };

  const submitEditChanges = async () => {
    props.updateResource(editModalData)
      .then((response: any) => {
        for (const file of response) {
          notifier.success(`"${file.RmiFileDesc} - ${file.RmiFileName}" successfully updated.`);
        }
        closeEditResources();
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      refreshFormTabs();
    });
  };

  // customRequest to just return a success to attach file to the form instead being actually uploading yet
  const customRequest = ({ onSuccess }: any) => {
    setTimeout(() => onSuccess('Success'), 0);
  };

  const handleRemove = (index: number) => {
    const fileArray = [...fileAttachments];
    const documentListArray = [...documentList];
    setFileAttachments(fileArray.filter((_, fileIndex) => fileIndex !== index));
    setDocumentList(documentListArray.filter((_, documentIndex) => documentIndex !== index));
  };

  const updateDocumentList = (e: any, index: number, property: string) => {
    const updatedDocumentList = documentList.map((item: ResourceFiles, itemIndex: number) => {
      if (itemIndex === index) {
        if (property === 'language') return { ...item, RmiLanguage: e };
        else if (property === 'ipa') return { ...item, RmiCompanyId: e};
        else if (property === 'fileDesc') return { ...item, RmiFileDesc: e.target.value };
        else if (property === 'fileLocation') {
          return { ...item, RmiLocationPath: JSON.parse(e).RmiLocationPath, RmiMaterialType: JSON.parse(e).RmiMaterialType, documentFileLocation: e }
        };
      }
      return item;
    });

    setDocumentList(updatedDocumentList);
  }

  const beforeUpload = (file: UploadFile) => {
    const ext = file.name.substr(file.name.lastIndexOf('.') + 1);
    const allowFiles = ['xls', 'xlsx', 'csv','tif', 'tiff', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'XLS', 'XLSX', 'CSV', 'TIF','TIFF','JPG','JPEG','PDF','DOC','DOCX'].includes(ext);
    if (!allowFiles) {
      message.error('You can only upload tif, tiff, jpg, jpeg, pdf, doc, docx, TIF, TIFF, JPG, JPEG, PDF, DOC, or DOCX file!');
      return false;
    } else {
      //file attachment used to list out the files under the dragger and cannot have duplicate files attached
      if (fileAttachments.filter(attachment => attachment.name === file.name).length === 0) {
        setFileAttachments((previous: any) => ([...previous, file]));
        setDocumentList((previous: any) => ([...previous, {
          RmiCompanyId: '',
          RmiCreatedBy: '',
          RmiCreatedDate: '',
          RmiFileName: '',
          RmiFileDesc: '',
          RmiLanguage: '',
          RmiLocationPath: '',
          RmiMaterialType: '',
          RmiModifiedBy: '',
          RmiModifiedDate: '',
          documentFileLocation: '',
          File: file,
        }]));
      } else {
        notifier.error('Please attach a file with a different name.');
      }
      return false;
    };
  };

  const getIpas = () => {
    return props.getAllDesc()
      .then((response: any) => {
        const ipaList = sortArrayByKey(response, 'RmiCompanyId');
        setIpaList(ipaList);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  return (
    <div className="flex-lg-wrap justify-content-start">
      {sessionStorage.user_role === UserRole.ADMIN ?
        <Button className={styles['green-button']} style={{ 'position': 'absolute', 'right': '0px', 'zIndex': 10 }} onClick={() => setIsAddNewDocumentsVisible(true)}>Add New Document</Button>
      : null }
      <Tabs
        type="card"
        className="print-tab-section member-search tabs row flex-lg-wrap justify-content-start ml-0"
        activeKey={activeKey}
        onChange={(onChange) => switchTabs(onChange)}
      >
        <TabPane tab="Current Forms" key="1">
        <Table
          dataSource={uniqueList}
          columns={currentFormTab}
          pagination={false}
          rowKey={'RmiFileDesc'}
          loading={props.isFetchingForms}
        />
        </TabPane>
        {sessionStorage.user_role === UserRole.ADMIN ?
          <TabPane tab="Archive" key="2">
          <Table
            dataSource={uniqueList1}
            columns={archiveTab}
            pagination={false}
            rowKey={'RmiFileDesc'}
            loading={props.isFetchingForms}
          />
          </TabPane>
        : null}
      </Tabs>

      <Modal
        visible={showEditResource}
        width={1000}
        maskClosable={false}
        onCancel={closeEditResources}
        footer={[
          <Button
            key="cancel"
            onClick={closeEditResources}
          >
            Close
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={submitEditChanges}
            loading={props.isUploadingResources}
          >
            Save
          </Button>,
        ]}
      >
        <Title level={3}>Edit Document</Title>

        <Divider/>

        <Form
          form={form}
          name={'editDocumentForm'}
          onFinish={submitEditChanges}
        >
          <Form.Item>
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th style={{width: '50%', textAlign: 'left'}}>Document File:</th>
                  <th style={{width: '50%', textAlign: 'left'}}>Location:</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{padding: '0 10px', border: '1px solid #d9d9d9', borderRadius: '2px'}}>
                    {editModalData[0]?.RmiFileName}
                  </td>
                  <td>
                    <Select
                      style={{
                        width: '100%',
                      }}
                      value={editDocumentFileLocation}
                      onChange={value => updateFileLocation(value)}
                    >
                    <Select.Option key={"Current_Forms"} value={JSON.stringify({RmiMaterialType: "FORM", RmiLocationPath: "Forms\\Questionnaires\\"})}>
                        Forms \ Current Forms
                      </Select.Option>
                      <Select.Option key={"Form_Archive"} value={JSON.stringify({RmiMaterialType: "Forms(A)", RmiLocationPath: "Forms\\Education\\"})}>
                        Forms \ Archive
                      </Select.Option>
                      <Select.Option key={"NMM_Updates"} value={JSON.stringify({RmiMaterialType: "NMM_U", RmiLocationPath: "Forms\\Provider\\"})}>
                        NMM Updates
                      </Select.Option>
                      <Select.Option key={"Risk_Adjustments"} value={JSON.stringify({RmiMaterialType: "HCC", RmiLocationPath: "Forms\\HCC\\"})}>
                        Provider Resources \ Risk Adjustments
                      </Select.Option>
                      <Select.Option key={"Quality_Care_Improvements"} value={JSON.stringify({RmiMaterialType: "PROV(H)", RmiLocationPath: "Forms\\HCC\\"})}>
                        Provider Resources \ Quality Care Improvement
                      </Select.Option>
                      <Select.Option key={"Provider_Resources"} value={JSON.stringify({RmiMaterialType: "PROV(C)", RmiLocationPath: "Forms\\Provider\\"})}>
                        Provider Resources \ Compliance
                      </Select.Option>
                      <Select.Option key={"UM"} value={JSON.stringify({RmiMaterialType: "PROV(UM)", RmiLocationPath: "Forms\\Provider\\"})}>
                        Provider Resources \ UM
                      </Select.Option>
                      <Select.Option key={"Provider_Manual"} value={JSON.stringify({RmiMaterialType: "PROV", RmiLocationPath: "Forms\\Provider\\"})}>
                        Provider Resources \ Provider Relations
                      </Select.Option>
                      <Select.Option key={"Member_Experience_PT"} value={JSON.stringify({RmiMaterialType: "PROV(ME)PT", RmiLocationPath: "Forms\\Provider\\"})}>
                        Provider Resources \ Member Experience \ Provider Training
                      </Select.Option>
                      <Select.Option key={"Member_Experience_PN"} value={JSON.stringify({RmiMaterialType: "PROV(ME)PN", RmiLocationPath: "Forms\\Provider\\"})}>
                        Provider Resources \ Member Experience \ Provider Newsletter
                      </Select.Option>
                      <Select.Option key={"Member_Experience_PO"} value={JSON.stringify({RmiMaterialType: "PROV(ME)PO", RmiLocationPath: "Forms\\Provider\\"})}>
                        Provider Resources \ Member Experience \ Patient Outreach
                      </Select.Option>
                      <Select.Option key={"Educational_Material"} value={JSON.stringify({RmiMaterialType: "EDU(P)", RmiLocationPath: "Forms\\Education\\"})}>
                        Patient Resources \ Patient Educational Material
                      </Select.Option>
                    </Select>
                  </td>
                </tr>
              </tbody>
            </table>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        visible={isAddNewDocumentsVisible}
        width={1250}
        maskClosable={false}
        onCancel={closeAddNewResources}
        footer={[
          <Button
            key="cancel"
            onClick={closeAddNewResources}
          >
            Close
          </Button>,
          <Button
            key="submit"
            type="primary"
            form="attachmentForm"
            onClick={submitNewDocument}
          >
            Save
          </Button>,
        ]}
      >
        <Title level={3}>Add Document</Title>

        <Divider/>

        <Form
          form={form}
          name={'documentCategoryForm'}
          onFinish={submitNewDocument}
          initialValues={{
            measureYear: moment().year().toString()
          }}
        >
          <Dragger
            fileList={fileAttachments}
            customRequest={customRequest}
            beforeUpload={beforeUpload}
            multiple={true}
            showUploadList={false}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag a file at a time to this area to upload</p>
          </Dragger>
          {documentList.map((option: ResourceFiles, index: number) => {
            return <>
              <div className="row">
                <div className="col-lg-24 col-md-24">
                  <Form.Item>
                    <table className="mt-4" style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th style={{width: '30%', textAlign: 'left'}}>Document Name:<span style={{color: 'red'}}>*</span></th>
                          <th style={{width: '20%', textAlign: 'left'}}>Document File:</th>
                          <th style={{width: '10%', textAlign: 'left'}}>IPA:<span style={{color: 'red'}}>*</span></th>
                          <th style={{width: '10%', textAlign: 'left'}}>Language:<span style={{color: 'red'}}>*</span></th>
                          <th style={{width: '40%', textAlign: 'left'}}>Location:<span style={{color: 'red'}}>*</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <Input onChange={(value) => updateDocumentList(value, index, 'fileDesc')} />
                          </td>
                          <td style={{padding: '0 10px', border: '1px solid #d9d9d9', borderRadius: '2px'}}>
                            {option.File.name}
                            <span style={{float: 'right', marginRight: '5px'}}>
                              <DeleteFilled className="ml-1" onClick={() => handleRemove(index)} />
                            </span>
                          </td>
                          <td>
                            <Select
                              style={{
                                width: '100%',
                              }}
                              value={documentList[index].RmiCompanyId}
                              onChange={value => updateDocumentList(value, index, 'ipa')}
                              showSearch
                            >
                              <Option value={ALL_IPAS}>ALL IPAs</Option>
                              {ipaList.map((option: any, index: number) => {
                                return <Option key={index} value={option.RmiCompanyId}>{getDisplayCompanyId(option.RmiCompanyId)}</Option>;
                              })}
                            </Select>
                          </td>
                          <td>
                            <Select
                              style={{
                                width: '100%',
                              }}
                              value={documentList[index].RmiLanguage}
                              onChange={value => updateDocumentList(value, index, 'language')}
                            >
                              {DOCUMENTS_LANGUAGE.map((language: any) => {
                                return <Option key={language} value={language}>{language}</Option>;
                              })}
                            </Select>
                          </td>
                          <td>
                            <Select
                              style={{
                                width: '100%',
                              }}
                              value={option.documentFileLocation}
                              onChange={value => updateDocumentList(value, index, 'fileLocation')}
                            >
                              <Select.Option key={"Current_Forms"} value={JSON.stringify({RmiMaterialType: "FORM", RmiLocationPath: "Forms\\Questionnaires\\"})}>
                                Forms \ Current Forms
                              </Select.Option>
                            </Select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Form.Item>
                </div>
              </div>
            </>
          })}
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingForms: store.rootReducer.app.isFetchingResources,
  isDownloadingResources: store.rootReducer.app.isFetchingFile,
  isUploadingResources: store.rootReducer.app.isUploadingResources,
  isDeletingResources: store.rootReducer.app.isDeletingResources,
  isUpdatingResources: store.rootReducer.app.isUpdatingResources,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
{
  getDownloadableResources,
  deleteResource,
  updateResource,
  uploadResource,
  getDownloadResources,
  getResources,
  getAllDesc,
},
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(FormsTable);
